export const DEFAULT_DRAG_HANDLE_CONTAINER_HEIGHT = 36;
export const DRAG_HANDLE_GRABBER_HEIGHT = 12;
export const DRAG_HANDLE_GRABBER_WIDTH = 4;
export const DRAG_HANDLE_GRABBER_BORDER_RADIUS = 1;
export const NOTE_CONTAINER_PADDING = 24;
